import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { Project } from '../types';
interface ProjectsProps {
  projects: Project[];
  isLoading: boolean;
}
const Projects: React.FC<ProjectsProps> = ({
  projects,
  isLoading
}) => {
  const [activeCategory, setActiveCategory] = useState<string>('all');
  const categories = useMemo(() => {
    const cats = projects.map(p => p.category);
    return ['all', ...Array.from(new Set(cats))];
  }, [projects]);
  const filteredProjects = useMemo(() => {
    if (activeCategory === 'all') return projects;
    return projects.filter(p => p.category === activeCategory);
  }, [projects, activeCategory]);
  return <div className="max-w-screen-2xl mx-auto px-6 md:px-12 pt-[104px] md:pt-32 pb-24" data-id="element-339">
      <header className="mb-12 md:mb-20 space-y-6" data-id="element-340">
        <h1 className="text-5xl md:text-9xl font-extrabold tracking-tighter" data-id="element-341">
          <span className="mr-4 opacity-80" data-id="element-342">📁</span>
          projects
        </h1>

        <div className="w-full" data-id="element-343">
          <p className="text-2xl md:text-4xl leading-tight tracking-tight text-zinc-300 font-medium" data-id="element-344">
            A collection of ideas I turned into real, usable experiences.
          </p>
        </div>
      </header>

      {/* ✅ MOBILE HORIZONTAL SCROLL FILTERS */}
      <div className="mb-12 md:mb-16" data-id="element-345">
        <div className="flex gap-3 overflow-x-auto md:overflow-visible md:flex-wrap pb-2" data-id="element-346">
          {categories.map(cat => <button key={cat} onClick={() => setActiveCategory(cat)} className={`flex-shrink-0 px-6 py-2 rounded-full text-[10px] font-extrabold uppercase tracking-widest transition-all border cursor-target ${activeCategory === cat ? 'bg-white text-black border-white' : 'bg-transparent text-zinc-500 border-white/10 hover:border-white/30 hover:text-white'}`} data-id="element-347">
              {cat}
            </button>)}
        </div>
      </div>

      {isLoading ? <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-8 gap-y-12 md:gap-y-16 animate-pulse" data-id="element-348">
          {[1, 2, 3, 4, 5, 6, 7, 8].map(i => <div key={i} className="space-y-4" data-id="element-349">
              <div className="aspect-video bg-zinc-900 rounded-sm" data-id="element-350" />
              <div className="h-4 bg-zinc-900 w-1/2 rounded" data-id="element-351" />
              <div className="h-6 bg-zinc-900 w-3/4 rounded" data-id="element-352" />
            </div>)}
        </div> : <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-8 gap-y-12 md:gap-y-16 animate-in fade-in slide-in-from-bottom-4 duration-700" data-id="element-353">
          {filteredProjects.map(project => <Link key={project.id} to={`/projects/${project.slug}`} className="group block space-y-4 md:space-y-6 cursor-target" data-id="element-354">
              <div className="aspect-video w-full overflow-hidden rounded-sm relative shadow-xl bg-zinc-900 border border-white/5" data-id="element-355">
                <img src={project.coverImage} alt={project.title} className="w-full h-full object-cover opacity-80 grayscale group-hover:grayscale-0 group-hover:scale-105 group-hover:opacity-100 transition-all duration-1000 ease-out" data-id="element-356" />
              </div>

              <div className="px-1 flex justify-between items-start" data-id="element-357">
                <div data-id="element-358">
                  <span className="text-[9px] text-zinc-500 uppercase tracking-[0.2em] block mb-2 font-extrabold" data-id="element-359">
                    {project.year} — {project.category}
                  </span>

                  <h3 className="text-xl md:text-[clamp(1.25rem,2.5vw,1.5rem)] font-extrabold tracking-tighter lowercase leading-tight group-hover:translate-x-1 transition-transform duration-500 [text-wrap:balance]" data-id="element-360">
                    {project.title}
                  </h3>
                </div>

                <div className="text-xl opacity-0 group-hover:opacity-100 transition-all duration-500 -translate-x-2 group-hover:translate-x-0" data-id="element-361">
                  →
                </div>
              </div>
            </Link>)}
        </div>}
    </div>;
};
export default Projects;